import styled, { css } from 'styled-components';
import { mediaMixin, spaceMixin, token } from '@zillow/constellation';

import MediumIllustrationHouse1x from '../../../images/MediumIllustrationHouse@1x.png';
import MediumIllustrationHouse2x from '../../../images/MediumIllustrationHouse@2x.png';

type StyledPropertyPhotoContainerProps = { primaryPhotoUrl: string };
export const StyledPropertyPhotoContainer = styled.div<StyledPropertyPhotoContainerProps>`
  background-color: ${token('colors.aqua600')};
  background-image: url(${(props) => props.primaryPhotoUrl || MediumIllustrationHouse2x});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: ${(props) => (props.primaryPhotoUrl ? 'cover' : '70px')};
  border-radius: ${spaceMixin(0.5)};
  margin-right: ${spaceMixin('xs')};
  width: 93px;

  ${mediaMixin(
    'md',
    css<StyledPropertyPhotoContainerProps>`
      background-image: url(${(props) => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse1x)});
      background-size: ${(props) => (props.primaryPhotoUrl ? 'cover' : '105px')};
      width: 156px;
      margin-right: ${spaceMixin('sm')};
    `,
  )}
`;

export const StyledReviewSection = styled.div`
  margin-bottom: ${spaceMixin('lg')};
`;

export const StyledReviewTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-bottom: ${spaceMixin('sm')};
`;

export const StyledIconPlaceholder = styled.div`
  display: inline-block;
  margin-right: 8px;
  width: 15px;
  max-height: 15px;

  flex-shrink: 0;
`;
